import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/view-all.svg")